import { Base64 } from "js-base64"
import config from '@/web.config.js'
let state = {
    routeList: [],
    isLoadRoute: false, //是否已经加载菜单
    dictionary: null,
    permissions: null,
    appName: config.appName, // 应用名称
    appShortName: config.appShortName, // 应用简称
    webTitle: '-', // 页面标题
    userInfo: null, // 当前用户信息
    menuList: [] // 用户菜单，保存，避免重载（刷新）再去重新请求
};

// 复制状态副本用于重置 state
const stateCopy = JSON.parse(JSON.stringify(state))
export default {
    namespaced: false, // 不使用命名空间，如果使用请在调用的地方使用路径如：app/GET_USERINFO
    state,
    getters: {
        // 获取当前用户信息
        // GET_USERINFO(state) {
        //     if (!state.userInfo) {
        //         state.userInfo = window.localStorage.userInfo ?
        //             JSON.parse(Base64.decode(window.localStorage.userInfo)) :
        //             null

        //     }
        //     return state.userInfo
        // },
        // 获取字典
        GET_DICTIONARY: state => type => {
            if (!type) return
            return state.dictionary[type.toUpperCase()]
        },
        // 获取页面标题
        GET_WEBTITLE(state) {
            return state.webTitle ? state.appShortName : state.appName;
        }
    },
    mutations: {
        SET_IS_LOADROUTE(state, val) {
            state.isLoadRoute = val // 加载菜单标识 ，避免多次请求数据
        },
        SET_WEBTITLE(state, value) {
            state.webTitle = value
        },
        SET_USERINFO(state, val) {
            state.userInfo = val
        },
        // 登录进入系统时保存当前用户菜单
        SAVE_MENULIST(state, menu) {
            state.menuList = menu
        },
        // 保存字典
        SET_DICTIONARY(state, value) {
            state.dictionary = value
        },
        // 重置树状态, 一般用于退出。
        RESET_STATE(state) {
            for (var i in stateCopy) {
                state[i] = stateCopy[i] // 递归赋值
            }
        },
        // 设置权限
        SET_PERMISSIONS(state, value) {
            state.permissions = value
        },
        SET_ROUTELIST(state, value) {
            state.routeList = value
        }
    },
    actions: {
        ACT_SET_DICTIONARY({
            commit,
            state
        }) {
            // 如果当前已存在字典
            if (sessionStorage.dictionary) {
                commit('SET_DICTIONARY', JSON.parse(sessionStorage.dictionary))
                console.log('已从缓存获取字典')
                return
            }
            // http.base.GET_DICTIONARY().then(res => {
            //   if (res.status === 'S') {
            //     const newObj = {}
            //     Object.keys(res.data).forEach(key => {
            //       newObj[key] = res.data[key].map(item => {
            //         return {
            //           value: item.code,
            //           label: item.name
            //         }
            //       })
            //     })
            //     commit('SET_DICTIONARY', newObj)
            //     sessionStorage.dictionary = JSON.stringify(newObj)
            //     console.log('当前从后端获取字典')
            //   }
            // })
        }
    }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/app.js